var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "auto-delete-outlined-20px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Space-Fix",
    transform: "translate(-389.000000, -144.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(389.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "12.8571429 1.28571429 10.2857143 1.28571429 9 0 3.85714286 0 2.57142857 1.28571429 0 1.28571429 0 2.57142857 12.8571429 2.57142857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2142857,6.42857143 C11.9957143,6.42857143 11.79,6.46714286 11.5714286,6.49285714 L11.5714286,3.85714286 L1.28571429,3.85714286 L1.28571429,14.1428571 C1.28571429,14.85 1.86428571,15.4285714 2.57142857,15.4285714 L7.40571429,15.4285714 C8.44714286,16.9842857 10.2085714,18 12.2142857,18 C15.4157143,18 18,15.4157143 18,12.2142857 C18,9.01285714 15.4157143,6.42857143 12.2142857,6.42857143 Z M6.78857143,14.1428571 L2.57142857,14.1428571 L2.57142857,5.14285714 L10.2857143,5.14285714 L10.2857143,6.78857143 C8.04857143,7.58571429 6.42857143,9.69428571 6.42857143,12.2142857 C6.42857143,12.8957143 6.57,13.5385714 6.78857143,14.1428571 Z M12.2142857,16.7142857 C9.73285714,16.7142857 7.71428571,14.6957143 7.71428571,12.2142857 C7.71428571,9.73285714 9.73285714,7.71428571 12.2142857,7.71428571 C14.6957143,7.71428571 16.7142857,9.73285714 16.7142857,12.2142857 C16.7142857,14.6957143 14.6957143,16.7142857 12.2142857,16.7142857 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "12.8571429 12.1114286 12.8571429 9 11.5714286 9 11.5714286 12.8571429 14.9142857 14.7857143 15.5571429 13.6671429"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.7bd5b70c.svg";
export { ForwardRef as ReactComponent };